import { render, staticRenderFns } from "./BaseConversationPanel.vue?vue&type=template&id=bd5c1ac0&scoped=true&"
import script from "./BaseConversationPanel.vue?vue&type=script&lang=js&"
export * from "./BaseConversationPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseConversationPanel.vue?vue&type=style&index=0&id=bd5c1ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5c1ac0",
  null
  
)

export default component.exports